import React from 'react';
import ReactModal from 'react-modal';
import useWindowSizes from 'shared/hooks/useWindowSizes';
import { getZoom } from 'shared/utils/appHelpers';
import { ArrowLeftLargeIcon, TimesIcon } from '../Icons';

const Modal = ({ isOpen, children, className, onCloseModal, onBackClick }) => {
  const [width] = useWindowSizes();

  return (
    <ReactModal
      isOpen={isOpen}
      className={className}
      style={{
        content: {
          zoom: getZoom(width + 200),
        },
      }}
    >
      <button className='btn p-0 modal-close' onClick={onCloseModal}>
        <TimesIcon />
      </button>
      {onBackClick && (
        <button className='btn p-0 modal-back' onClick={onBackClick}>
          <ArrowLeftLargeIcon />
        </button>
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
